import React, { lazy } from 'react';

const CompanyHome = lazy(
  () => import('../CompanyRoutes/CompanyHomepage/CompanyHome.page.jsx')
);
const UploadForm = lazy(
  () => import('../CompanyRoutes/CreateRoutes/UploadForm/UploadForms.page.jsx')
);
const CreateSubcontractor = lazy(
  () =>
    import(
      '../CompanyRoutes/CreateRoutes/CreateSubContractor/Subcontractor.page.jsx'
    )
);
const CreateManagerCompany = lazy(
  () =>
    import(
      '../CompanyRoutes/CreateRoutes/CreateManagerEmployee/CreateME.page.jsx'
    )
);
const CompleteTransactionCompany = lazy(
  () =>
    import(
      '../CompanyRoutes/CompanyBuyCourses/TransactionComplete/CompleteTransactionCompany.page.jsx'
    )
);
const PurchaseHistory = lazy(
  () => import('../CompanyRoutes/PurchaseHistory/PurchasedHistory.page.jsx')
);
const CompanyPurchaseCourses = lazy(
  () => import('../CompanyRoutes/CompanyBuyCourses/CompanyBuyCourse.page.jsx')
);
const CompanyPurchasedCoursesList = lazy(
  () => import('../CompanyRoutes/PurchasedCourses/TrainingList.page.jsx')
);
const CompanyEmployeesPage = lazy(
  () => import('../CompanyRoutes/CompanyEmployeeList/CompanyEmployees.page.jsx')
);
// const CompanyFormsPage = lazy(
//   () => import('../CompanyRoutes/CompanyHomepage/CompanyForms.component.jsx')
// );
const CompanySettingsPage = lazy(
  () => import('../CompanyRoutes/CompanySetting/CompanySettings.page.jsx')
);
const FormHomepageCompany = lazy(
  () => import('../Forms/CompanyForms/FormHomepageCompany.page.jsx')
);
const SingleForm = lazy(
  () => import('../Forms/CompanyForms/SingleFormHomepage.page.jsx')
);
const ManualHomepage = lazy(
  () => import('../CompanyRoutes/Manual/ManualHomepage.page.jsx')
);
const FormInstancesPage = lazy(
  () =>
    import(
      '../Forms/CompanyForms/FormInstancesPageCompany/FormInstancesPage.page.jsx'
    )
);
const UserDetailsBasePage = lazy(
  () => import('../UserDetails/UserDetails.page.jsx')
);
const TrainingSubscription = lazy(
  () =>
    import(
      '../CompanyRoutes/TrainingSubscription/TrainingSubscription.page.jsx'
    )
);
// import ProvinceHomepage from '../Provinces/ProvinceHomepage/Province.component.jsx';
// import ProvincesList from '../Provinces/ProvincesList/ProvincesList.component.jsx';
// const ProvinceDashboard = lazy(
//   () => import('../Provinces/ProvinceDashboard/ProvinceDashboard.component.jsx')
// );
// const UserToProvince = lazy(
//   () => import('../CompanyRoutes/UserToProvince/UserToProvince.component.jsx')
// );

export const companyRoutes = [
  { path: '', element: <CompanyHome /> },
  { path: 'upload-form/:id', element: <UploadForm /> },
  { path: 'create-manager-employee/:id', element: <CreateManagerCompany /> },
  { path: 'purchase-history/:id', element: <PurchaseHistory /> },
  { path: 'create-subcontractor/:id', element: <CreateSubcontractor /> },
  { path: 'training-list/:id', element: <CompanyPurchasedCoursesList /> },
  { path: 'buy-courses/:companyId', element: <CompanyPurchaseCourses /> },
  { path: 'transaction-completed', element: <CompleteTransactionCompany /> },
  // { path: 'forms/:id', element: <CompanyFormsPage /> },
  { path: 'employees/:id', element: <CompanyEmployeesPage /> },
  { path: 'settings/:id', element: <CompanySettingsPage /> },
  { path: ':id/forms', element: <FormHomepageCompany /> },
  {
    path: ':companyId/forms/edit/:formId/:instanceId',
    element: <SingleForm />,
  },
  { path: 'manual/:id', element: <ManualHomepage /> },
  {
    path: ':companyId/forms/:formId',
    element: <FormInstancesPage />,
  },
  {
    path: 'training-subscription/:companyId',
    element: <TrainingSubscription />,
  },
  { path: 'employee/:id', element: <UserDetailsBasePage /> },
  // { path: ':companyId/province/:provinceId', element: <ProvinceDashboard /> },
  // {
  //   path: ':companyId/province/:provinceId/forms/edit/:formId',
  //   element: <SingleForm />,
  // },
  // { path: 'user-to-province/:companyId', element: <UserToProvince /> },
  // { path: 'provinces', element: <ProvincesList /> },
  // { path: 'provinces/:id', element: <ProvinceHomepage /> },
];
